module.exports = __webpack_public_path__ + "img/Stemness-OVCA_10X_TPCP.8d6f9c76.png";